import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { DecimalPipe } from '@angular/common';

@Component({
  selector: 'lib-tree-actions',
  imports: [DecimalPipe],
  templateUrl: './tree-actions.component.html',
  styleUrl: './tree-actions.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class TreeActionsComponent {
  zoom = input.required<number>();
  isMaximized = input.required<boolean>();
  isPdfLoading = input.required<boolean>();
  handleZoomOut = output<void>();
  handleZoomIn = output<void>();
  handleMaximize = output<void>();
  handleExportPDF = output<void>();

  zoomOut() {
    this.handleZoomOut.emit();
  }

  zoomIn() {
    this.handleZoomIn.emit();
  }

  maximize() {
    this.handleMaximize.emit();
  }

  exportPDF() {
    this.handleExportPDF.emit();
  }
}
